(ns practitest.frontend.components2.dashboard.charts.line.render-axis
  (:require
   [practitest.frontend.components2.dashboard.charts.line.helper :as helper]
   [practitest.frontend.components2.dashboard.charts.render-helpers :as rh]
   ["d3" :as d3]))

(defn- rotate-x-axis-labels! [x-axis-group chart]
  (let [{:config/keys [x-axis-rotate-label-angle x-offset-after-rotation]} chart
        transform-rotate (str "rotate(" x-axis-rotate-label-angle ")")]
    (-> x-axis-group
        (.selectAll "text")
        (.attr "transform" transform-rotate)
        (.attr "x" (:x x-offset-after-rotation))
        (.attr "y" (:y x-offset-after-rotation))
        (.attr "dy" (:dy x-offset-after-rotation))
        (.style "text-anchor" "end"))))

(defn- render-horizontal-grid-lines! [svg chart scale tick-values]
  (let [{:keys [width]
         :config/keys [padding]} chart
        grid-group (rh/ensure-group! svg "grid-lines")
        lines (-> grid-group
                  (.selectAll ".y-grid-line")
                  (.data tick-values))]
    (-> (.enter lines)
        (.append "line")
        (.attr "class" "y-grid-line")
        (.merge lines)
        (.attr "x1" (:left padding))
        (.attr "x2" (- width (:right padding)))
        (.attr "y1" #(scale %))
        (.attr "y2" #(scale %))
        (.attr "stroke" (or (:grid-stroke chart) "#e0e0e0"))
        (.attr "stroke-width" (or (:grid-stroke-width chart) 1)))
    (-> (.exit lines) (.remove))))

(defn- x-tick-values [chart data]
  (if (:config/date-format-for-x-axis chart)
    (->> data (keep :parsed-x) clj->js)
    (->> data (map :x-data) clj->js)))

(defn- render-x-axis! [svg chart data scale]
  (let [{:config/keys [date-format-for-x-axis int-format-for-digit-axis height padding]} chart
        tick-format (if date-format-for-x-axis
                      (.utcFormat d3 date-format-for-x-axis)
                      (.format d3 int-format-for-digit-axis))
        tick-values (x-tick-values chart data)
        x-axis-group (rh/ensure-group! svg "x-axis"
                       (str "translate(0," (- height (:bottom padding)) ")"))]
    (-> x-axis-group
        (.call (-> d3
                   (.axisBottom scale)
                   (.tickValues tick-values)
                   (.tickFormat tick-format))))
    (rotate-x-axis-labels! x-axis-group chart)))

(defn- render-y-axis!
  [svg chart data scale]
  (let [{:config/keys [padding y-data-minimum-value int-format-for-digit-axis]} chart
        max-val      (if (seq data) (apply max (map :y-data data)) 0)
        domain-max   (max max-val y-data-minimum-value)
        tick-values  (if (<= domain-max y-data-minimum-value)
                       (clj->js (range y-data-minimum-value))
                       (.ticks scale y-data-minimum-value))
        axis-group   (rh/ensure-group! svg "y-axis"
                       (str "translate(" (:left padding) ",0)"))]
    (-> axis-group
        (.call (-> d3
                   (.axisLeft scale)
                   (.tickValues tick-values)
                   (.tickFormat (.format d3 int-format-for-digit-axis)))))
    (when (:config/draw-grid? chart)
      (render-horizontal-grid-lines! svg chart scale tick-values))
    (when (:config/remove-y-axis-line? chart)
      (.call axis-group (fn [g] (.remove (.select g ".domain")))))
    axis-group))

(defn render-axis!
  [svg chart lines scales hidden-lines]
  (let [visible (filterv #(not (contains? hidden-lines (:line-name %))) lines)
        domain-data (or (helper/get-data-with-max-y-data visible)
                        (helper/get-data-with-max-y-data lines)
                        [])]
    (when (seq domain-data)
      (render-x-axis! svg chart domain-data (:x-scale scales))
      (render-y-axis! svg chart domain-data (:y-scale scales)))))
